/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

// Import Form
import { Form, Col, Row, FormControl, Button } from "react-bootstrap";
import uploadService from "../../services/uploadfile.service";

/* eslint-enable */

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

// Import Modal
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

function MemberForm(props) {
  const [formmember, setFormmember] = useState({});
  const [errors, setErrors] = useState({});
  // const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [filename, setFilename] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  // const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const ref = useRef();

  const handleClose = () => {
    props.hidden_func(false);
    // props.assocdata({});
    // props = [];
    setErrors({});
    setFormmember({});
  };

  const setField = (field, value) => {
    if (field.files) {
      if (field.name === "approve_file") {
        console.log(field.name);
        console.log(field.files[0]);
        setFormmember({
          ...formmember,
          [field.name]: field.files[0],
        });
      } else {
        // setImage({
        //   preview: URL.createObjectURL(field.files[0]),
        // });
        setFormmember({
          ...formmember,
          [field.name]: field.files[0],
        });
      }
    } else {
      if (errors[field.name])
        setErrors({
          ...errors,
          [field.name]: null,
        });

      setFormmember({
        ...formmember,
        [field.name]: value,
      });
    }
  };
  const findFormErrors = () => {
    // const { memberNumber } = form;
    const newErrors = {};

    // start date errors
    // if (!memberNumber || memberNumber == "")
    //   newErrors.memberNumber = "กรุณากรอกเลขสมาชิก";

    return newErrors;
  };

  useEffect(() => {
    // console.log(props);
    const birthdate = new Date(props.farmerdata.birth_date);
    setFormmember({
      ...formmember,
      ["birth_date"]: birthdate.toLocaleString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
    });
  }, [props]);

  const handleAdd = (e) => {
    e.preventDefault();
    const data = new FormData();

    data.append("singlefileUpload", selectedFile, filename);
    data.append("associd", props.assocdata.association_id);
    data.append("cardid", props.farmerdata.id_card);
    setLoading(true);
    uploadService
      .uploadMemberDocFile(data)
      .then((response) => {
        setFiles([...files, response.data.data.filename]);
        ref.current.value = "";
        // setPreviewImage(null);
        setSelectedFile(null);
        setFilename("filename.jpg");
        // setSelectedFile(e.target.files[0]);
        // let fileExt = e.target.files[0].name.split(".");
        // console.log(fileExt[1]);
        // // setFilename(e.target.files[0].name);
        // let newFilename = props.farmerdata.id_card + "." + fileExt[1];
        // setFilename(newFilename);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function handleChange(e) {
    e.preventDefault();
    setSelectedFile(e.target.files[0]);
    let fileExt = e.target.files[0].name.split(".");
    console.log(fileExt.length);
    // setFilename(e.target.files[0].name);
    let ext_num = fileExt.length - 1;
    let newFilename = props.farmerdata.id_card + "." + fileExt[ext_num];
    setFilename(newFilename);
    console.log(newFilename);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const newform = {
        assoc_id: props.assocdata.association_id,
        farmer_id: props.farmerdata.farmer_id,
        member_code: formmember.memberNumber,
        person_card: props.farmerdata.id_card,
      };
      props.onsubmit(newform);
      console.log(newform);
      console.log(props.assocdata);
    }
  };

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Modal size="md" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>เพิ่มข้อมูลสมาชิก</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          สมาคม : {" " + props.assocdata.assocname}
          <br />
          ชื่อ - นามสกุล :{" "}
          {props.farmerdata.pre_name +
            " " +
            props.farmerdata.first_name +
            " " +
            props.farmerdata.last_name}
          <br />
          หมายเลขบัตร :{" " + props.farmerdata.id_card}
          <br />
          ที่อยู่ :{" "}
          {props.farmerdata.address +
            " " +
            props.farmerdata.tam_namt +
            " " +
            props.farmerdata.amp_namt +
            " " +
            props.farmerdata.prov_namt}
          <br />
          เพศ : {props.farmerdata.sex}
          <br />
          วันเกิด : {formmember.birth_date}
          <br />
          เบอร์โทร : {props.farmerdata.tel}
          <hr />
          <Form>
            <Form.Group as={Row} className="mb-12">
              <FormControl
                type="number"
                name="assoc_id"
                value={props.assocdata.association_id}
                hidden={true}
              />
              <Form.Control.Feedback type="invalid">
                {errors.assoc_id}
              </Form.Control.Feedback>
              <Row>
                <Col sm="4">หมายเลขสมาชิก :</Col>
                <Col sm="8">
                  <FormControl
                    placeholder="กรอกหมายเลขสมาชิก"
                    type="number"
                    name="memberNumber"
                    value={formmember.memberNumber}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.memberNumber}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.memberNumber}
                  </Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col sm="4">เอกสารยืนยัน :</Col>
                <Col sm="8">
                  <input type="file" ref={ref} onChange={handleChange} />
                  <button className="btn btn-primary" onClick={handleAdd}>
                    เพิ่มเอกสาร
                  </button>
                  <Form.Control.Feedback type="invalid">
                    {errors.memberNumber}
                  </Form.Control.Feedback>
                </Col>
              </Row>
            </Form.Group>
          </Form>
          {/* {JSON.stringify(props)} */}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ปิด
          </button>
          <button
            className="btn btn-primary"
            // type="submit"
            onClick={handleSubmit}
          >
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MemberForm;

MemberForm.propTypes = {
  show: PropTypes.bool,
  hidden_func: PropTypes.func,
  onsubmit: PropTypes.func,
  farmerdata: PropTypes.object,
  assocdata: PropTypes.object,
};

MemberForm.defaultProps = {
  assocdata: {
    association_id: "",
    association_name_th: "",
  },
  farmerdata: {
    pre_name: "",
    first_name: "",
    last_name: "",
    address: "",
    tam_namt: "",
    amp_namt: "",
    prov_namt: "",
    sex: "",
    birth_date: "",
    tel: "",
  },
};
